import { addToMyCalendar } from 'owa-locstrings/lib/strings/addtomycalendar.locstring.json';
import loc from 'owa-localize';
import { ControlIcons } from 'owa-control-icons';
import type { ViewType } from 'owa-calendar-actions';
import { canAddToMyCalendar, isSeriesInstance } from 'owa-calendar-event-capabilities';
import { addCalendarEventToMyCalendar } from 'owa-calendar-events-actions';
import type { CalendarEvent } from 'owa-calendar-types';
import { getAddEventToMyCalendarMenuItems } from 'owa-event-context-menu';
import { DisplayOption, FilterableMenuItem, FilterableMenuItemArgs } from 'owa-filterable-menu';

/**
 * Returns the button for add event to my calendar
 * @param event Calendar event
 * @param actionSource Calendar view
 */
export const getAddToMyCalendarButton = (
    event: CalendarEvent,
    actionSource: ViewType
): FilterableMenuItem => {
    let onClick;
    let menuItems;

    if (!isSeriesInstance(event)) {
        onClick = () => addCalendarEventToMyCalendar(event.ItemId, actionSource);
    } else {
        menuItems = getAddEventToMyCalendarMenuItems(event, actionSource);
    }

    return new FilterableMenuItem({
        [FilterableMenuItemArgs.name]: loc(addToMyCalendar),
        [FilterableMenuItemArgs.icon]: ControlIcons.AddEvent,
        [FilterableMenuItemArgs.onClick]: onClick,
        [FilterableMenuItemArgs.shouldShow]: () => canAddToMyCalendar(event),
        [FilterableMenuItemArgs.displayOption]: DisplayOption.Left,
        [FilterableMenuItemArgs.menuContent]: menuItems,
        [FilterableMenuItemArgs.key]: 'AddToMyCalendar',
    });
};
